import {Complete} from "@/pages/common/Home/Features/Complete";
import {Intro} from "@/pages/common/Home/Features/Intro";
import {Accordeon} from "@/pages/common/Home/components/Accordeon";
import {PreviewSlider} from "@/pages/common/Home/components/PreviewSlider";
import {Try} from "@/pages/common/Home/components/Try";

import chatScreenEn from "@images/home/features/chat-screen-en.png";
import chatScreenRu from "@images/home/features/chat-screen-ru.png";
import profileScreenEn from "@images/home/features/profile-screen-en.png";
import profileScreenRu from "@images/home/features/profile-screen-ru.jpg";
import simulationsScreenEn from "@images/home/features/simulations-screen-en.png";
import simulationsScreenRu from "@images/home/features/simulations-screen-ru.png";
import {usePopup} from "@layouts/popup/InfoPopup/PopupContext";
import {PresentationPopup} from "@popups/requestPopups/PresentationPopup";
import {Helmet} from "react-helmet";
import {useTranslation} from "react-i18next";
import {useSelector} from "react-redux";

import styles from "./styles.module.scss";

export const Features = () => {
  const {t} = useTranslation();
  const {language} = useSelector((state) => state.common.settings);

  const accordeonItems = [
    {
      id: 0,
      head: (
        <span
          dangerouslySetInnerHTML={{
            __html: t("page.features.packages.table.title_1"),
          }}
        />
      ),
      body: (
        <span
          dangerouslySetInnerHTML={{
            __html: t("page.features.packages.table.desc_1"),
          }}
        />
      ),
      check_1: true,
      check_2: true,
    },
    {
      id: 1,
      head: (
        <span
          dangerouslySetInnerHTML={{
            __html: t("page.features.packages.table.title_2"),
          }}
        />
      ),
      body: (
        <span
          dangerouslySetInnerHTML={{
            __html: t("page.features.packages.table.desc_2"),
          }}
        />
      ),
      check_1: true,
      check_2: true,
    },
    {
      id: 2,
      head: (
        <span
          dangerouslySetInnerHTML={{
            __html: t("page.features.packages.table.title_3"),
          }}
        />
      ),
      body: (
        <span
          dangerouslySetInnerHTML={{
            __html: t("page.features.packages.table.desc_3"),
          }}
        />
      ),
      check_1: true,
      check_2: true,
    },
    {
      id: 3,
      head: (
        <span
          dangerouslySetInnerHTML={{
            __html: t("page.features.packages.table.title_4"),
          }}
        />
      ),
      body: (
        <span
          dangerouslySetInnerHTML={{
            __html: t("page.features.packages.table.desc_4"),
          }}
        />
      ),
      check_1: false,
      check_2: true,
    },
    {
      id: 4,
      head: (
        <span
          dangerouslySetInnerHTML={{
            __html: t("page.features.packages.table.title_5"),
          }}
        />
      ),
      body: (
        <span
          dangerouslySetInnerHTML={{
            __html: t("page.features.packages.table.desc_5"),
          }}
        />
      ),
      check_1: false,
      check_2: true,
    },
    {
      id: 5,
      head: (
        <span
          dangerouslySetInnerHTML={{
            __html: t("page.features.packages.table.title_6"),
          }}
        />
      ),
      body: (
        <span
          dangerouslySetInnerHTML={{
            __html: t("page.features.packages.table.desc_6"),
          }}
        />
      ),
      check_1: false,
      check_2: true,
    },
    {
      id: 6,
      head: (
        <span
          dangerouslySetInnerHTML={{
            __html: t("page.features.packages.table.title_7"),
          }}
        />
      ),
      body: (
        <span
          dangerouslySetInnerHTML={{
            __html: t("page.features.packages.table.desc_7"),
          }}
        />
      ),
      check_1: false,
      check_2: true,
    },
    {
      id: 7,
      head: (
        <span
          dangerouslySetInnerHTML={{
            __html: t("page.features.packages.table.title_8"),
          }}
        />
      ),
      body: (
        <span
          dangerouslySetInnerHTML={{
            __html: t("page.features.packages.table.desc_8"),
          }}
        />
      ),
      check_1: false,
      check_2: true,
    },
    {
      id: 8,
      head: (
        <span
          dangerouslySetInnerHTML={{
            __html: t("page.features.packages.table.title_9"),
          }}
        />
      ),
      body: (
        <span
          dangerouslySetInnerHTML={{
            __html: t("page.features.packages.table.desc_9"),
          }}
        />
      ),
      check_1: false,
      check_2: true,
    },
    {
      id: 9,
      head: (
        <span
          dangerouslySetInnerHTML={{
            __html: t("page.features.packages.table.title_10"),
          }}
        />
      ),
      body: (
        <span
          dangerouslySetInnerHTML={{
            __html: t("page.features.packages.table.desc_10"),
          }}
        />
      ),
      check_1: false,
      check_2: true,
    },
  ];

  const sliderItems = [
    {
      id: 0,
      block: (
        <img
          src={language === "en" ? simulationsScreenEn : simulationsScreenRu}
          alt={`preview-screenshot`}
        />
      ),
    },
    {
      id: 1,
      block: (
        <img
          src={language === "en" ? chatScreenEn : chatScreenRu}
          alt={`preview-screenshot`}
        />
      ),
    },
    {
      id: 2,
      block: (
        <img
          src={language === "en" ? profileScreenEn : profileScreenRu}
          alt={`preview-screenshot`}
        />
      ),
    },
  ];

  const {openPopup} = usePopup();

  const handleOpenPopup = () => {
    openPopup(<PresentationPopup />);
  };

  return (
    <>
      <Helmet title={t("head_title.features")} />

      <div className={"container-big"}>
        <div className={styles.features_page}>
          <Intro />

          <div className={"container-home"}>
            <Accordeon
              title={
                <span
                  dangerouslySetInnerHTML={{
                    __html: t("page.features.packages.title"),
                  }}
                />
              }
              tableHead={[
                t("page.features.packages.table.head_1"),
                t("page.features.packages.table.head_2"),
                t("page.features.packages.table.head_3"),
              ]}
              items={accordeonItems}
              subtitle={
                <span
                  dangerouslySetInnerHTML={{
                    __html: t("page.features.packages.subtitle"),
                  }}
                />
              }
            />
          </div>

          <div className={"container-home"}>
            <Try
              onClickBtn={handleOpenPopup}
              size={35}
              title={
                <b
                  dangerouslySetInnerHTML={{
                    __html: t("page.features.packages.try"),
                  }}
                />
              }
            />
          </div>

          <PreviewSlider cards={sliderItems} />

          <div className={"container-home"}>
            <Complete />
          </div>
        </div>
      </div>
    </>
  );
};
